'use client';

import dynamic from 'next/dynamic';
import type { RatesData } from '@/app_data/widgets/RedVentures/utils';
import type { RatesTypes } from '@/app_lib/utils/widgets/redVenturesConstants';

const RatesWidget = dynamic(
  () => import('@/app_components/widgets/RatesWidget/RatesWidget').then((mod) => mod.RatesWidget),
  { ssr: false },
);

interface RatesWidgetProps {
  className?: string;
  userZipCode?: string;
  type: RatesTypes;
  initialData?: RatesData[];
  postId: number;
}

export const CdRatesWidgetClient = (props: RatesWidgetProps) => {
  return <RatesWidget {...props} />;
};

export const SavingsWidgetClient = (props: RatesWidgetProps) => {
  return <RatesWidget {...props} />;
};
